export default {
  namespaced: true,
  state: {
    snacks: []
  },
  getters: {
    snacks(state) {
      return state.snacks;
    }
  },
  mutations: {
    add(state, [text, color = "success"]) {
      state.snacks.push({ text, color });
    }
  }
};